<app-toast-host></app-toast-host>
<app-confirm-host></app-confirm-host>

@if (navigating) {
    <div class="app-nav-progress" role="progressbar" aria-label="Loading">
        <div class="app-nav-progress__bar"></div>
    </div>
}

<router-outlet></router-outlet>
